import { ApiProvider } from './../../providers/api/api';
import { AddCallPage } from './../add-call/add-call';
import { Contact, Deal, Meeting, Call, Operator, DealStatus } from './../../models/models';
import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ModalController,
  ActionSheetController,
  ActionSheetButton,
  AlertController
} from 'ionic-angular';
import { SettingsProvider } from '../../providers/settings/settings';
import { AddMeetingPage } from '../add-meeting/add-meeting';
import { OperatorProvider } from '../../providers/operator/operator';
import { CallsProvider } from '../../providers/api/calls.provider';
import { MeetingPage } from '../meeting/meeting';
import { CallDetailPage } from '../call-detail/call-detail';
import {tap} from "rxjs/operators";
import {ContactProvider} from "../../providers/api/contacts.provider";


@IonicPage()
@Component({
  selector: 'page-contact-detail',
  templateUrl: 'contact-detail.html',
})
export class ContactDetailPage {
  contact: Contact = null
  parent = null
  deals: Deal[]

  meetingsPlanned: Meeting[] = []
  callsPlanned: Call[] = []
  operator: Operator;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public settings: SettingsProvider,
    private modalCtrl: ModalController,
    private readonly apiProvider: ApiProvider,
    private readonly operatorProvider: OperatorProvider,
    private readonly callsProvider: CallsProvider,
    private readonly actionSheetController: ActionSheetController,
    private contactProvider: ContactProvider,
    private api: ApiProvider,
    private alertCtrl: AlertController
  ) {
    if (typeof navParams.get('contact') != 'undefined') {
      this.contact = navParams.get('contact')
      this.parent = (navParams && navParams.get('parent')) || null

      this.deals = this.contact.deals.filter(deal => this.settings.PRODUCTS.some(p => p == deal.product.ac_label ))

      this.operatorProvider.currentOperator.subscribe(operator => {
        this.operator = operator
        this.deals.forEach(deal => {
          this.apiProvider.getPlannedMeetingsFor(operator.id, deal.id).subscribe(
            page => {
              this.meetingsPlanned.push(...page.results)
            },
            _e => { })
          this.callsProvider.getCalls(false, deal.id).subscribe(calls => {
            this.callsPlanned.push(...calls.results)
          })

        })

      })
    }
  }

  get checked(): Boolean {
    return this.deals.some(d => d.is_hot)
  }

  get products(): String {
    return Array.from(new Set(this.deals.map(d => d.product.name ))).join(", ")
  }

  openMeeting(meeting: Meeting) {
    this.navCtrl.push(MeetingPage, {
      meeting: meeting,
      parent: this,
      operator: this.operator
    })
  }

  openCall(call: Call) {
    this.navCtrl.push(CallDetailPage, {
      call: call,
      parent: this
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ContactDetailPage');
  }

  selectDeal(deals: Deal[], selectionHandler: (deal: Deal, create: boolean, product_id: number) => void) {
    let myp_deal = deals.find(deal => deal.product.ac_label == this.settings.PRODUCT_MYP)
    let social_deal = deals.find(deal => deal.product.ac_label == this.settings.PRODUCT_SOCIAL)

    let buttons: ActionSheetButton[] = deals
    .map(deal => {
      return {
        text: `${deal.product.name}`,
        handler: () => {
          selectionHandler(deal, false, null)
        }
      }
    })
    if (!myp_deal) {
      buttons.push({
        text: `${this.settings.PRODUCT_MYP}`,
        handler: () => {
          selectionHandler(null, true, this.settings.PRODUCT_MYP_ID)
        }
      })
    }
    if (!social_deal) {
      buttons.push({
        text: `${this.settings.PRODUCT_SOCIAL}`,
        handler: () => {
          selectionHandler(null, true, this.settings.PRODUCT_SOCIAL_ID)
        }
      })
    }

    buttons.push({
      text: 'Annulla',
      icon: 'close',
      role: 'cancel',
      handler: () => {
        console.log('Cancel clicked');
      }
    })


    const actionSheet = this.actionSheetController.create({
      title: 'Seleziona Deal',
      buttons: buttons
    });
    actionSheet.present();
  }

  createMeeting(contact: Contact) {
    if (contact != null) {
      console.log('Creo un meeting con', this.contact.name)

      let deals = this.deals.filter(deal => deal.status == DealStatus.OPEN && this.settings.PRODUCTS.some(p => p == (deal.product && deal.product.ac_label)))

      this.selectDeal(deals, (deal, create, product_id) => {
        if (create) {
          let product_label = product_id == this.settings.PRODUCT_SOCIAL_ID ? this.settings.PRODUCT_SOCIAL : this.settings.PRODUCT_MYP

          return this.api.postDeal(
            contact.id,
            product_id,
            this.settings.PIPELINE_VENDITA_BY_PRODUCT[product_label],
            this.settings.STAGE_APPOINTMENT_TODO_BY_PRODUCT[product_label],
            this.operator.id
          ).pipe(tap(
            _ => {
              this.contactProvider.pushOnAC(contact.id).subscribe(_ => {
              })
            }
          )).subscribe(deal => {
            let meetingModal = this.modalCtrl.create(AddMeetingPage, {
              contact: contact,
              deal: deal
            }, {showBackdrop: true})
            meetingModal.onDidDismiss(_value => {
            })
            meetingModal.present()
          }, e => {
            this.alertCtrl.create({
              title: "Anomalia",
              message: "Si è verificato un errore",
              buttons: [
                {
                  text: 'Ok',
                  handler: () => {
                  }
                },
              ]
            }).present()
            console.log(e)
          })

        } else {
          let meetingModal = this.modalCtrl.create(AddMeetingPage, {
            contact: contact,
            deal: deal
          }, {showBackdrop: true})
          meetingModal.onDidDismiss(_value => {
          })
          meetingModal.present()
        }
      })
    }
  }

  createCall(contact: Contact) {
    if (contact != null) {
      console.log('Creo un call con', this.contact.name)

      let deals = this.deals.filter(deal => deal.status == DealStatus.OPEN && this.settings.PRODUCTS.some(p => p == (deal.product && deal.product.ac_label)))

      this.selectDeal(deals, (deal, create, product_id) => {
        if (create) {
          let product_label = product_id == this.settings.PRODUCT_SOCIAL_ID ? this.settings.PRODUCT_SOCIAL : this.settings.PRODUCT_MYP

          return this.api.postDeal(
            contact.id,
            product_id,
            this.settings.PIPELINE_VENDITA_BY_PRODUCT[product_label],
            this.settings.STAGE_APPOINTMENT_TODO_BY_PRODUCT[product_label],
            this.operator.id
          ).pipe(tap(
            _ => {
              this.contactProvider.pushOnAC(contact.id).subscribe(_ => {
              })
            }
          )).subscribe(deal => {
            let meetingModal = this.modalCtrl.create(AddMeetingPage, {
              contact: contact,
              deal: deal
            }, {showBackdrop: true})
            meetingModal.onDidDismiss(_value => {
            })
            meetingModal.present()
          }, e => {
            this.alertCtrl.create({
              title: "Anomalia",
              message: "Si è verificato un errore",
              buttons: [
                {
                  text: 'Ok',
                  handler: () => {
                  }
                },
              ]
            }).present()
            console.log(e)
          })

        } else {
          let callModal = this.modalCtrl.create(AddCallPage, {contact: contact, deal: deal}, {showBackdrop: true})
          callModal.onDidDismiss(_value => {
          })
          callModal.present()
        }
      })
    }
  }

  markAsHot(_contact: Contact) {
    this.deals.forEach( deal => {
      if (deal.id && deal.is_hot != null) {
        let oldStatus = deal.is_hot
        deal.is_hot = !this.checked

        this.apiProvider.markDealAsHot(deal.id, deal.is_hot).subscribe(data => {
          console.log('PATCH FATTO - DEAL IS HOT?', data.is_hot)
          deal.is_hot = data.is_hot
        }, error => {
          console.log('PATCH NON FATTO, RIPRISTINO IL DEAL A' + oldStatus + "\n Errore: ", error)
          deal.is_hot = oldStatus
        })
      }
    })
  }


  callContact() {
    window.open('tel:' + this.contact.phone, '_system', 'location=yes')
  }

}



// WEBPACK FOOTER //
// ./src/pages/contact-detail/contact-detail.ts